(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('polevento-announcements')) {
    customElements.define('polevento-announcements', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        clearInterval(this.timer);
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.slides = Array.from(this.querySelectorAll('.pv-ann-slide'));
        this.index = 0;
        this.stopped = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.show(0);
        this.querySelectorAll('[data-direction]').forEach(button => {
          button.addEventListener('click', () => {
            this.stopped = true;
            this.pause();
            this.querySelector('.pv-ann-messages').setAttribute('aria-live', 'polite');
            this.show(this.index + Number(button.dataset.direction));
          }, options);
        });
        this.addEventListener('mouseenter', () => this.pause(), options);
        this.addEventListener('mouseleave', () => this.play(), options);
        this.addEventListener('focusin', () => this.pause(), options);
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) this.play();
        }, options);
        document.addEventListener('visibilitychange', () => document.hidden ? this.pause() : this.play(), options);
        this.motion.addEventListener('change', () => this.play(), options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.stopped = true;
          this.pause();
          this.show(index);
        }, options);
        this.play();
      }
      show(index) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      }
      pause() { clearInterval(this.timer); }
      play() {
        this.pause();
        if (this.dataset.rotate !== 'true' || this.slides.length < 2 || this.stopped || this.motion.matches || document.hidden || this.contains(document.activeElement)) return;
        this.timer = setInterval(() => this.show(this.index + 1), Math.max(3, Number(this.dataset.speed) || 4) * 1000);
      }
      disconnectedCallback() { this.pause(); this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["polevento-countdown"]) return;
  try {
    
  if (!customElements.get('polevento-countdown')) customElements.define('polevento-countdown', class extends HTMLElement {
    connectedCallback() {
      const end = Date.parse(this.dataset.end);
      if (!Number.isFinite(end)) return;
      const tick = () => {
        const total = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (total === 0) { this.hidden = true; clearInterval(this.timer); return; }
        const times = { hours: Math.floor(total / 3600), minutes: Math.floor(total / 60) % 60, seconds: total % 60 };
        Object.entries(times).forEach(([key, value]) => { this.querySelector('[data-time="' + key + '"]').textContent = String(value).padStart(2, '0'); });
        this.querySelector('.pv-clock').hidden = false;
      };
      tick();
      this.timer = setInterval(tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });

  } catch(e) { console.error(e); }
})();
})();
